import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCiodJCjRjDjUbCmbDlU5XscuXg85NR2FM",
  authDomain: "famconnect-a10e6.firebaseapp.com",
  projectId: "famconnect-a10e6",
  storageBucket: "famconnect-a10e6.firebasestorage.app",
  messagingSenderId: "906530275281",
  appId: "1:906530275281:web:a1d840f0d2fce4c9956af0",
  measurementId: "G-JYXGWDT5TQ",
};

export const app = initializeApp(firebaseConfig);
export default app;
